import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LandingInversoresRoutingModule } from './landing-inversores-routing.module';
import { LandingInversoresComponent } from './landing-inversores.component';

import { LandingIconComponent } from './components/landing-icon/landing-icon.component';
import { LandingLogoComponent } from './components/landing-logo/landing-logo.component';
import { LandingHeaderComponent } from './components/landing-header/landing-header.component';
import { LandingHeroComponent } from './components/landing-hero/landing-hero.component';
import { LandingLeadFormComponent } from './components/landing-lead-form/landing-lead-form.component';
import { LandingTrustStatsComponent } from './components/landing-trust-stats/landing-trust-stats.component';
import { LandingMediaComponent } from './components/landing-media/landing-media.component';
import { LandingProcessComponent } from './components/landing-process/landing-process.component';
import { LandingInvestmentTypesComponent } from './components/landing-investment-types/landing-investment-types.component';
import { LandingValuePropsComponent } from './components/landing-value-props/landing-value-props.component';
import { LandingTestimonialsComponent } from './components/landing-testimonials/landing-testimonials.component';
import { LandingValueServicesComponent } from './components/landing-value-services/landing-value-services.component';
import { LandingFaqComponent } from './components/landing-faq/landing-faq.component';
import { LandingFinalCtaComponent } from './components/landing-final-cta/landing-final-cta.component';
import { LandingFooterComponent } from './components/landing-footer/landing-footer.component';

import { LandingFormService } from './services/landing-form.service';
import { LandingAnalyticsService } from './services/landing-analytics.service';
import { LandingSeoService } from './services/landing-seo.service';

@NgModule({
  declarations: [
    LandingInversoresComponent,
    LandingIconComponent,
    LandingLogoComponent,
    LandingHeaderComponent,
    LandingHeroComponent,
    LandingLeadFormComponent,
    LandingTrustStatsComponent,
    LandingMediaComponent,
    LandingProcessComponent,
    LandingInvestmentTypesComponent,
    LandingValuePropsComponent,
    LandingTestimonialsComponent,
    LandingValueServicesComponent,
    LandingFaqComponent,
    LandingFinalCtaComponent,
    LandingFooterComponent,
  ],
  imports: [
    // Solo lo estrictamente necesario de Angular: directivas estructurales (*ngFor,
    // *ngIf, *ngSwitch) y el routing propio de la feature. Nada de Bootstrap,
    // Material, ngx-translate ni ReactiveFormsModule (el formulario de HubSpot no
    // tiene campos Angular que controlar, ver services/landing-form.service.ts).
    CommonModule,
    LandingInversoresRoutingModule,
  ],
  providers: [LandingFormService, LandingAnalyticsService, LandingSeoService],
})
export class LandingInversoresModule {}
